import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 54344 46005"
    {...props}
  >
    <defs>
      <style>
        {".str0{stroke:#000;stroke-width:602.219}.fil0{fill:#2b2a29}"}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_2528315469360">
        <path
          d="M50968 2324H3376c-206 0-374-167-374-374 0-206 168-373 374-373h47592c206 0 373 167 373 373 0 207-167 374-373 374z"
          className="fill stroke1"
          style={{
            strokeWidth: 602.219,
            strokeLinejoin: "round",
          }}
        />
        <path
          d="M1951 1047c-498 0-903 406-903 903 0 498 405 904 902 904 499 0 904-406 904-904 0-497-405-903-903-903zm0 2553c-910 0-1650-740-1650-1650 0-909 740-1649 1649-1649 910 0 1651 740 1651 1649 0 910-741 1650-1650 1650zM52393 1047c-498 0-903 406-903 903 0 498 404 904 903 904 498 0 903-406 903-904 0-497-405-903-903-903zm0 2553c-910 0-1650-740-1650-1650 1-909 740-1649 1650-1649s1649 740 1649 1649c0 910-740 1650-1649 1650zM5500 45704h-483V1950c0-206 167-373 373-373 205 0 373 167 373 373l1 42990c427-60 815-264 1114-588 359-391 532-896 487-1425l-473-5608c-17-204 135-384 341-403 205-18 386 135 403 341l473 5608c62 728-187 1454-682 1992-494 539-1196 847-1927 847z"
                    className="fill stroke1"
          style={{
            strokeWidth: 602.219,
            strokeLinejoin: "round",
          }}

        />
        <path
          d="M7943 43107c-207 0-373-168-373-373 0-206 166-373 373-373 530 0 1019-215 1378-606 359-390 532-896 487-1424l-473-5608c-17-205 135-385 340-404 206-17 386 136 404 342l473 5607c62 728-187 1454-682 1992-494 539-1196 848-1927 847z"
                    className="fill stroke1"
          style={{
            strokeWidth: 602.219,
            strokeLinejoin: "round",
          }}

        />
        <path
          d="M10386 40685c-207 0-374-167-374-373s167-373 374-373c530 0 1019-215 1378-605 359-391 532-896 487-1424l-473-5608c-17-206 135-387 340-404 205-18 386 136 404 340l473 5609c62 727-187 1454-682 1992-494 537-1196 846-1927 846z"
                    className="fill stroke1"
          style={{
            strokeWidth: 602.219,
            strokeLinejoin: "round",
          }}

        />
        <path
          d="M12870 38264h-42c-206 0-373-167-373-373 0-207 167-374 373-374h42c524 0 1010-211 1367-594 359-381 536-880 502-1403l-519-7751c-13-205 142-383 348-396 205-15 383 141 397 347l518 7750c48 721-207 1437-700 1964s-1190 830-1913 830z"
                    className="fill stroke1"
          style={{
            strokeWidth: 602.219,
            strokeLinejoin: "round",
          }}

        />
        <path
          d="M15376 28358c-106 0-215-14-321-43-3590-996-9754-3705-9816-3733-188-82-274-303-191-492 84-189 303-274 492-190 62 27 6176 2714 9715 3695 223 62 461-53 554-266 54-123 53-258-2-381-55-122-156-212-284-254-1987-641-6973-2359-10331-4447-174-109-228-339-120-514 109-175 339-229 515-120 3287 2044 8204 3738 10166 4372 326 105 593 343 735 656 139 312 143 671 6 986-195 451-644 731-1118 731z"
                    className="fill stroke1"
          style={{
            strokeWidth: 602.219,
            strokeLinejoin: "round",
          }}

        />
        <path
          d="M13973 26151c-139 0-272-77-336-210-90-185-14-408 172-498 34-17 3409-1685 6678-5402 3010-3422 6546-9336 6306-18080-6-207 157-378 362-384 209-6 378 157 383 363 110 3972-525 7715-1888 11125-1090 2729-2646 5250-4624 7493-3368 3821-6749 5488-6890 5556-53 26-109 37-163 37zM7943 19465c-207 0-373-168-373-374V7736c0-207 166-374 373-374 206 0 373 167 373 374v11355c0 206-168 374-373 374zM49327 45704h-483c-731 0-1433-308-1928-847-495-538-743-1264-681-1992l473-5608c17-206 196-359 403-341 205 19 358 199 340 403l-472 5608c-45 529 128 1035 486 1425 299 324 688 528 1116 588V1950c0-206 166-373 373-373 206 0 373 167 373 373v43754z"
                    className="fill stroke1"
          style={{
            strokeWidth: 602.219,
            strokeLinejoin: "round",
          }}

        />
        <path
          d="M46401 43107c-731 0-1433-308-1928-847-494-538-743-1264-681-1992l473-5608c18-206 196-358 403-341 205 19 359 199 340 404l-472 5608c-45 528 128 1034 487 1424 358 391 848 606 1378 606 206 0 373 167 373 373 1 205-167 374-373 373z"
                    className="fill stroke1"
          style={{
            strokeWidth: 602.219,
            strokeLinejoin: "round",
          }}

        />
        <path
          d="M43958 40685c-731 0-1433-309-1928-846-494-538-742-1265-681-1992l473-5609c17-204 197-358 403-340 205 17 359 198 340 404l-472 5607c-45 529 128 1034 487 1425 359 390 849 605 1378 605 206 0 373 167 373 373 1 206-167 373-373 373z"
                    className="fill stroke1"
          style={{
            strokeWidth: 602.219,
            strokeLinejoin: "round",
          }}

        />
        <path
          d="M41515 38264h-42c-722 0-1419-303-1913-830-492-528-749-1243-700-1964l518-7750c15-206 194-362 398-347 206 13 361 191 347 396l-518 7751c-35 522 142 1022 501 1403 357 383 843 594 1367 594h42c206 0 373 167 373 374 1 205-167 373-373 373z"
                    className="fill stroke1"
          style={{
            strokeWidth: 602.219,
            strokeLinejoin: "round",
          }}

        />
        <path
          d="M38968 28358c-473 0-922-280-1118-731-136-315-135-674 6-986 141-313 409-551 734-656 1962-634 6878-2328 10167-4372 175-109 405-55 514 120s55 405-120 514c-3358 2088-8343 3806-10331 4447-128 42-228 132-283 254-56 123-57 258-3 381 93 213 331 328 555 266 3539-981 9653-3668 9714-3695 189-84 409 1 492 190 84 189-2 410-190 492-62 28-6226 2737-9817 3733-106 29-213 43-320 43z"
                    className="fill stroke1"
          style={{
            strokeWidth: 602.219,
            strokeLinejoin: "round",
          }}

        />
        <path
          d="M40372 26151c-56 0-112-11-164-37-142-68-3522-1735-6891-5556-1977-2243-3533-4764-4623-7493-1363-3410-1999-7153-1890-11125 7-206 178-369 384-363s368 177 363 384c-240 8744 3297 14658 6305 18080 3271 3717 6644 5385 6678 5402 186 90 264 313 173 499-64 132-197 209-335 209zM46401 19465c-206 0-373-168-373-374V7736c0-207 167-374 373-374s373 167 373 374l1 11355c0 206-168 374-374 374z"
                    className="fill stroke1"
          style={{
            strokeWidth: 602.219,
            strokeLinejoin: "round",
          }}

        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
